import React, { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import AdminRoutes from 'page/admin/admin.routes';
import AdminHeader from 'components/admin/common/AdminNavbar';
import AdminSidebar from 'components/admin/common/sidebar/AdminSidebar';
import { postData } from 'core/services/api';

const Admin = () => {
    const history = useHistory();

    useEffect(() => {
        const isAdmin = localStorage.getItem('isAdmin');
        const usuario = localStorage.getItem('usuario');

        if (isAdmin !== 'true' || !usuario) {
            history.push('/');
            return;
        }

        // Validar usuario con request a /login
        const validateUser = async () => {
            try {
                const response = await postData('/login', {
                    usuario: usuario,
                    password: 'password',
                });

                if (response?.data?.message === 'Usuario inválido') {
                    localStorage.setItem('isAdmin', 'false');
                    localStorage.removeItem('usuario');
                    history.push('/');
                    return;
                }
            } catch (err) {
                const message = err?.response?.data?.message || err?.response?.data?.error;
                if (message === 'Usuario inválido') {
                    localStorage.setItem('isAdmin', 'false');
                    localStorage.removeItem('usuario');
                    history.push('/');
                }
            }
        };

        validateUser();
    }, [history]);

    return (
        <div className="admin-container">
            <AdminSidebar />
            <div className="admin-content">
                <AdminHeader />
                <AdminRoutes />
            </div>
        </div>
    );
};

export default Admin;